module.exports = "/_next/static/images/584565a326d6fca46555e56c2861853c-forbes.png";